<template>
	<h1>节能报告预览</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>